import BaseService from 'services/BaseService';

//-------------------------------------------------------------------------------------------------------------------

export default class SupportService
    extends BaseService {

    static async listAreas() {
        return BaseService.callAPI('support/list-areas');
    }

    static async listTemplates(supportAreaID) {
        return BaseService.callAPI('support/list-templates/' + supportAreaID);
    }

    static async submitTicket(supportTicket) {
        return BaseService.callAPI('support/submit-ticket', supportTicket);
    }

    static async emergencySickness(bookingID) {
        return BaseService.callAPI('support/emergency-sickness', { bookingID });
    }

    static async emergencyWebex(bookingID, description) {
        return BaseService.callAPI('support/emergency-webex', { bookingID, description });
    }

}